import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-week-timer-card',
  template: `
    <div
      class="rounded border text-xs p-1 overflow-hidden h-full"
      [class.border-timer-active-border]="state === 'active'"
      [class.bg-timer-active-surface]="state === 'active'"
      [class.text-timer-active-fg]="state === 'active'"
      [class.border-timer-inactive-border]="state === 'inactive'"
      [class.bg-timer-inactive-surface]="state === 'inactive'"
      [class.text-timer-inactive-fg]="state === 'inactive'"
    >
      <p class="font-medium truncate leading-tight">{{ projectDisplayName }}</p>
      <p class="truncate leading-tight opacity-80">{{ positionDisplayName }}</p>
      <p class="leading-tight">
        {{ state === 'active' ? 'laufender Timer' : 'pausierter Timer' }} ·
        @if (sessionMinutes !== null) {
          {{ (sessionMinutes / 60).toFixed(1) }}h session ·
        }
        {{ (totalMinutes / 60).toFixed(1) }}h total
      </p>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WeekTimerCardComponent {
  @Input({ required: true }) state!: 'active' | 'inactive';
  @Input({ required: true }) totalMinutes!: number;
  @Input() sessionMinutes: number | null = null;
  @Input() projectDisplayName = 'Timer';
  @Input() positionDisplayName = 'Ohne Position';
}
